"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Yup = __importStar(require("yup"));
var i18n_1 = __importDefault(require("../i18n"));
require("./validators");
var savePostSchema = Yup.object({
    contact: Yup.object({
        contacts: Yup.array()
            .of(Yup.object().shape({
            phone: Yup.string().armPhone(i18n_1.default.t('common:ERROR_MESSAGES.INVALID_ARM_PHONE')),
        }))
            .unique(i18n_1.default.t('common:ERROR_MESSAGES.DUPLICATE_PHONE'), 'contact.contacts', 'phone')
            .requiredAtLeastOnePhoneNumber(i18n_1.default.t('common:ERROR_MESSAGES.REQUIRE_AT_LEAST_ONE_PHONE_NUMBER')),
    }),
});
exports.default = savePostSchema;
